import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IVolunteerActivity } from './models';
import { invalidateVolunteerActivities } from './useVolunteerActivities';
import { VOLUNTEER_ACTIVITY_MUTATION_SCOPE, volunteerActivityQueryKey } from './useVolunteerActivity';

export const useUpdateVolunteerActivityMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IVolunteerActivity) => void;
} = {}) => {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		scope: VOLUNTEER_ACTIVITY_MUTATION_SCOPE,
		mutationFn: ({
			activity,
			impersonationContext,
		}: {
			activity: IVolunteerActivity;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IVolunteerActivity>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `volunteering/activities/${activity.id}`,
				}),
				'PUT',
				activity
			),
		onSuccess: (data, { activity, impersonationContext }) => {
			queryClient.setQueryData(volunteerActivityQueryKey(activity.id, impersonationContext?.account?.id), data);
			invalidateVolunteerActivities();
			onSuccess?.(data);
		},
		onError,
	});
};
